import http from 'utils/http';
import { getAgencyVoiceCreationUrl, getAgencyVoicesUrl, getBusinessVoicesUrl } from './apiUrls';
import { VoiceMetaResponse, VoiceResponse } from './types';
import { MetaApiResponse } from 'utils/types/CommonApiResponse';

export function getBusinessVoices(
  workspaceId?: string,
  agentId?: string
): Promise<{ data: VoiceResponse[]; meta: VoiceMetaResponse }> {
  return http.get(getBusinessVoicesUrl(workspaceId, agentId));
}

export function createVoice(workspaceId?: string, agentId?: string, payload?: FormData): Promise<VoiceResponse> {
  return http.post(getAgencyVoiceCreationUrl(workspaceId, agentId), payload);
}

export function getAgencyVoices(): Promise<{ data: VoiceResponse[]; meta: MetaApiResponse }> {
  return http.get(getAgencyVoicesUrl());
}
